const initialState = {
  notifList: [],
  newOffer: false,
  UnRead: false,
};

export default function NotifsReducer(state = initialState, actions) {
  if (actions.type === "ADD_NOTIF") {
    const notifs = [...state.notifList];
    notifs.push(actions.payload);
    return {
      ...state,
      notifList: notifs,
    };
  }

  if (actions.type === "ADD_OFFER") {
    return {
      ...state,
      newOffer: actions.payload,
    };
  }
  if (actions.type === "MARK_READ") {
    return {
      ...state,
      UnRead: actions.payload,
      notifList: actions.payload ? state.notifList : [],
    };
  }
  return state;
}
